module.exports = __webpack_public_path__ + "static/media/info_red.24c00f06.svg";